import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ADMIN_WALLETS = [
  "0x3aBC06F18a86Fc1038A28547283488B64beff5f2".toLowerCase()
];

export const useAdminGuard = (account) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!account) return;
    if (!ADMIN_WALLETS.includes(account.toLowerCase())) {
      alert("Δεν έχεις πρόσβαση στο Admin Panel.");
      navigate('/');
    }
  }, [account, navigate]);
};
